import React from 'react';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react';

type snackType =
  | 'success'
  | 'warning'
  | 'error'
  | 'default'
  | 'info'
  | 'blocked'
  | 'severeWarning';
interface IDispatch {
  message?: string;
  type?: snackType;
  dismiss?: boolean;
}
interface dispatchFunc {
  (params: IDispatch): void;
}

interface showToastFunc {
  (message: string, type: snackType, options?: Object): void;
}
interface IState {
  visible: boolean;
  message: string;
  // icon: string;
  // color?: string;
  type: snackType;
}

export interface IToast {
  showToast: showToastFunc;
}

export const ToastContext = React.createContext<IToast>({
  // show: () => {},
  showToast: () => {},
});

export const ToastProvider: React.FC<any> = (props) => {
  const [state, dispatch]: [IState, dispatchFunc] = React.useReducer(
    (prevState: any, action: IDispatch) => {
      // let color;

      if (action.dismiss === true) {
        return {
          ...prevState,
          visible: false,
        };
      }

      // switch (action.type) {
      //   case 'success':
      //     color = '#357a38';

      //     break;
      //   case 'warning':
      //     color = '#ffa000';
      //     break;
      //   case 'error':
      //     color = '#d32f2f';
      //     break;
      //   default:
      //     color = '#313131';
      //     break;
      // }

      return {
        ...prevState,
        visible: true,
        // icon,
        // color: color,
        message: action.message,
        type: action.type,
      };
    },
    { visible: false, message: '', type: 'info' }
  );
  const toastContext = React.useMemo(
    () => ({
      showToast: (message: string, type: snackType) => {
        dispatch({ type, message });
        setTimeout(() => {
          dispatch({ dismiss: true });
        }, 3000);
      },
    }),
    []
  );
  return (
    <ToastContext.Provider value={toastContext}>
      <>
        {state.visible && (
          <div className='toast-message-container'>
            <MessageBar
              messageBarType={MessageBarType[state.type as any] as any}
              isMultiline={false}
              onDismiss={() => dispatch({ dismiss: true })}>
              {state.message}
            </MessageBar>
          </div>
        )}
        {props.children}
      </>
    </ToastContext.Provider>
  );
};

export const withToastContext = (ChildComponent: any) => (props: any) => {
  const { showToast } = React.useContext(ToastContext);
  return <ChildComponent {...props} showToast={showToast} />;
};
